<template>
  <div class="w-100">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />

    <div>
      <v-btn
        class="float-right"
        color="success"
        flat
        title="Neue Organisation erfassen"
        @click="createNew"
      >
        <i class="fas fa-plus mr-3" /> Erfassen
      </v-btn>

      <div class="col-4">
        <v-text-field
          id="searchInput"
          v-model="searchTerm"
          append-icon="fas fa-search"
          class="search--input"
          label="Nach Organisation suchen..."
        />
      </div>
      <div
        class="mt-5 ml-3"
        style="width: 100%"
      >
        <b-select
          v-model="resultsPerPage"
          class="custom-select ml-1"
          style="width: 62px; height: 31px; font-size: 12px"
        >
          <option :value="10">
            10
          </option>
          <option :value="25">
            25
          </option>
          <option :value="50">
            50
          </option>
          <option :value="100">
            100
          </option>
        </b-select>
        <label
          style="font-weight: bold; margin-left: 3px"
        >Anzahl Resultate</label>
        <b-pagination
          v-model="currentPage"
          :per-page="resultsPerPage"
          :total-rows="totalNumberOfContracts"
          class="float-right mr-3"
          first-text="<<"
          last-text=">>"
          next-text="Nächste"
          prev-text="Vorherige"
        />
      </div>
      <v-flex
        v-if="isLoading"
        justify-center
      >
        <u-loader />
      </v-flex>
      <table
        v-else
        class="w-100 organisationOverview ml-2 mt-5"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Name 2</th>
            <th>Ort</th>
            <th>Telefon</th>
            <th>Email</th>
            <th>Homepage</th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="organisation in organisations"
            :key="organisation.id"
          >
            <td>{{ organisation.name }}</td>
            <td>{{ organisation.name2 }}</td>
            <td>{{ organisation.city }}</td>
            <td>{{ organisation.phone }}</td>
            <td>{{ organisation.email }}</td>
            <td>{{ organisation.homepage }}</td>
            <td>
              <v-btn
                color="#007bff"
                dark
                fab
                small
                title="Bearbeiten"
                @click="editOrganisation(organisation.id)"
              >
                <i class="fas fa-edit" />
              </v-btn>
              <v-btn
                color="#e72b37"
                dark
                fab
                small
                title="Löschen"
                @click="deleteOrganisation(organisation.id)"
              >
                <i class="fas fa-trash" />
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  GetOragnisations,
  DeleteOrganisation,
} from "@/services/user.crm.service";

export default {
  data() {
    return {
      isLoading: false,
      errorObject: null,
      searchTerm: "",
      organisations: [],
      totalNumberOfContracts: 0,
      currentPage: 1,
      resultsPerPage: 25,
      sortOrder: 0,
      sortedProperty: "",
    };
  },
  watch: {
    searchTerm() {
      this.getOrganisations();
    },
    currentPage() {
      this.getOrganisations();
    },
    resultsPerPage() {
      this.currentPage = 1;
      this.getOrganisations();
    },
  },
  created() {
    if (this.$route.path === "/organisation") {
      this.getOrganisations();
    }
  },
  methods: {
    createNew() {
      this.$router.push({
        path: "organisation/create",
      });
    },
    editOrganisation(contactId) {
      this.$router.push({
        path: "organisation/edit?organisationNr=" + contactId,
      });
    },
    deleteOrganisation(organisationId) {
      this.isLoading = true;
      DeleteOrganisation(
        organisationId,
        () => {
          this.getOrganisations();
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    getOrganisations() {
      this.isLoading = true;
      GetOragnisations(
        this.resultsPerPage,
        this.currentPage,
        this.searchTerm,
        this.sortedProperty,
        this.sortOrder,
        (response) => {
          this.totalNumberOfContracts = response.numberOfItems;
          this.organisations = response.organisations;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.organisationOverview {
  font-size: small;
  table-layout: fixed;
}

.organisationOverview thead th:nth-child(1) {
  width: 20%;
}

.organisationOverview thead th:nth-child(2) {
  width: 15%;
}

.organisationOverview thead th:nth-child(3) {
  width: 10%;
}

.organisationOverview thead th:nth-child(4) {
  width: 15%;
}

.organisationOverview thead th:nth-child(5) {
  width: 15%;
}

.organisationOverview thead th:nth-child(6) {
  width: 15%;
}

.organisationOverview thead th:nth-child(8) {
  width: 10%;
}

.organisationOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.organisationOverview td,
.organisationOverview th {
  padding: 8px 4px;
}

/deep/ .page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #e72b37;
  border-color: red;
}

/deep/ .page-link:hover {
  z-index: 2;
  color: red;
  text-decoration: none;
  background-color: #fdd;
  border-color: #fdd;
}

/deep/ a:hover {
  color: #0056b3;
  text-decoration: underline;
}

/deep/ .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: red;
  background-color: rgb(255, 255, 255);
  border: 1px solid #dee2e6;
}

.custom-select.filled-input {
  border-bottom-color: red;
  background-color: #ededed;
  font-weight: bold;
  color: #333;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #aaa;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  padding: 0 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus {
  outline: none;
  border-bottom: 2px solid #333;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

/* CSS für den Pfeil */

.custom-select:after {
  content: "";

  position: absolute;

  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  margin-top: -4px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus:after {
  margin-top: -2px;
  border-top: 5px solid #fdd;
  transform: rotate(180deg);
}
</style>
